import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SessionServiceService } from '../services/session-service.service';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ToastService } from '../services/toast.service';
import { BackendService } from '../services/backend.service';
import { LoggerService } from "../services/logger/logger.service";
import { UI_ACTION_CONSTANTS } from '../services/logger/constants';
// added by Mo...
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { FeedbackService } from '../services/feedback.service';
import { Feedback } from 'src/classes/feedback.model';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmationComponent } from '../dialog-confirmation/dialog-confirmation.component';



@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  providers: [FeedbackService]
})

export class FeedbackComponent implements OnInit {
  // @Output() addFeedback: EventEmitter<any> = new EventEmitter();
  // public formGroup: FormGroup;

  feedback: Feedback = {
    wasHelpful: undefined,
    uiIsGood: undefined,
    iWillUseIt: undefined,
    suggestions: "",
    majorProblems: undefined
  }


  private _questions: string = 'How helpful was this tool? (1 - not really << to >> 5 - very much):\n\n\n' +
    'How would you rate the user interface? (1 - did not like it << to >> 5 - really liked it):\n\n\n' +
    'Would you use this tool to publish your educational ressources as OER? (yes <<>> no):\n\n\n' +
    'Would you recommend this tool to anybody else? (yes <<>> no):\n\n\n' +
    'Do you have any other ideas or thoughts regarding the tool? Something that could be improved? (free text):';

  public uploadCurrentFile: boolean = false;
  public feedbackSubmitted = false;
  public loading = false;

  constructor(
    private _session: SessionServiceService,
    private _toast: ToastService,
    private _backend: BackendService,
    public feedbackService: FeedbackService,
    private _logger: LoggerService,
    private _dialog: MatDialog
  ) { }

  ngOnInit() {
  }



  public reloadApp(): void {
    window.location.reload();
  }

  public getToolbarTitle(): string {
    return this._session.getToolName() + ' ' + this._session.getCurrentToolVersion();
  }

  public getCurrentFilename(): string {
    return this.isCurrentFileAvailabe() ? this._session.getFileHandler().getRawFile().file.name : "No file detected";
  }

  public isCurrentFileAvailabe(): boolean {
    return this._session.getFileHandler() !== undefined && this._session.getFileHandler().getRawFile() !== undefined;
  }

  public isValid(): boolean {
    return (this.feedback.iWillUseIt !== undefined && this.feedback.majorProblems !== undefined &&
      this.feedback.uiIsGood !== undefined && this.feedback.suggestions !== undefined && this.feedback.wasHelpful !== undefined);
  }

  submitFeedback() {
    console.log(this.feedback);
    if (this.uploadCurrentFile) {
      if (this.feedback.files === undefined) {
        this.feedback.files = [this._session.getFileHandler().getRawFile().file];
      } else {
        // assure that the _main_ file is always the first element in the feedback.files array
        // unpacking this.feedback.files as it is not an real array (i.e. it has no unshift function available)
        this.feedback.files = [(this._session.getFileHandler().getRawFile().file), ...this.feedback.files];
      }
    }
    this.loading = true;

    // log feedback submitted ui action
    this._logger.log(UI_ACTION_CONSTANTS.FEEDBACK_SUBMITTED, {
      /* eslint-disable @typescript-eslint/naming-convention */
      feedback_wasHelpful: this.feedback.wasHelpful.toString(),
      feedback_uiIsGood: this.feedback.uiIsGood.toString(),
      feedback_iWillUseIt: this.feedback.iWillUseIt.toString(),
      feedback_majorProblems: this.feedback.majorProblems.toString(),
      feedback_suggestions: this.feedback.suggestions.toString(),
    });

    this.feedbackService.postFeedback(this.feedback).then((res) => {
      this.feedbackSubmitted = true;
    }).catch((err) => {
      console.log('error on submitting feedback: ', err)
      this._session.alert("Sending Feedback failed!", "Sorry, we could not reach our server. Please try again later.");
    }).finally(() => {
      this.loading = false;
      this.feedback.files = [];
    });
  }

}
